import React from 'react';
import HeroSection from '../components/common/HeroSection';
import Team from '../components/foundation/Team';

const breadcrumb = [
  { key: 'nav.home',    path: '/' },
  { key: 'nav.ourTeam', path: null },
];

const OurTeam = () => (
  <>
    <HeroSection
      titleKey="team.title"
      subtitleKey="team.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <Team />
  </>
);

export default OurTeam;
